export var isArray = Array.isArray;
export function isNonEmptyArray(value) {
  return Array.isArray(value) && value.length > 0;
}